import {autoRegister} from "../container";

export const ERROR_REASON_CANCELLED = "eop_cancelled";
export const ERROR_REASON_TEST = "eop_error_test";

@autoRegister()
export class EopErrorHandler {
    public report(messageOrError: string | Error, ...data: unknown[]): void {
        if (messageOrError === ERROR_REASON_CANCELLED || messageOrError === ERROR_REASON_TEST) {
            return;
        }
        console.error(messageOrError, ...data);
    }
}